import Icon from '@vtblife/uikit-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { InfoStep } from '../info-step/info-step';
import { StepperForm } from '../stepper-form/stepper-form';
import styles from './quiz-content.module.css';
import { execPostSubmitAction } from './utils/exec-post-submit-action';
import { sendQuizAnalytics } from '../../utils/quiz-analytics';
export const QuizContent = ({ onLastStepSubmit: _onLastStepSubmit, onComplete, onNextStep, setCurrentStep, ...props }) => {
    var _a;
    const [resultPage, setResultPage] = useState(null);
    const [showStartPage, setShowStartPage] = useState(true);
    const { id: quizId, name: quizName } = props;
    const { steps = [], startPage, progressBar, layout, background, postSubmitAction } = props;
    const onLastStepSubmit = useCallback(async (props) => {
        const { formData } = props;
        await (_onLastStepSubmit === null || _onLastStepSubmit === void 0 ? void 0 : _onLastStepSubmit(props));
        if (postSubmitAction && postSubmitAction.length > 0) {
            execPostSubmitAction({ postSubmitAction, setResultPage, formData });
        }
    }, [postSubmitAction, setResultPage, _onLastStepSubmit]);
    const hasSteps = !!(steps === null || steps === void 0 ? void 0 : steps.length);
    useEffect(() => {
        if (!hasSteps) {
            onLastStepSubmit({ formData: {}, fields: [] });
        }
    }, [onLastStepSubmit, hasSteps]);
    useEffect(() => {
        if (showStartPage) {
            setCurrentStep(0);
            sendQuizAnalytics({
                quizName,
                quizId,
                quizStep: 0,
                quizAction: 'show',
            });
        }
    }, [showStartPage, quizName, quizId, setCurrentStep]);
    if (showStartPage && startPage) {
        return (React.createElement(StartPage, { ...startPage, onStart: () => {
                setShowStartPage(false);
                sendQuizAnalytics({ quizName, quizId, quizStep: 0, quizAction: 'continue' });
                setCurrentStep(1);
            }, layout: layout, imageSize: background === 'transparent' ? 's' : 'm', variant: background === 'transparent' ? 'modal' : 'default' }));
    }
    if (resultPage) {
        const resultPageIndex = (_a = props.postSubmitAction) === null || _a === void 0 ? void 0 : _a.findIndex((page) => { var _a; return ((_a = page.resultPage) === null || _a === void 0 ? void 0 : _a.title) === resultPage.title; });
        const resultPageStep = `result${resultPageIndex}`;
        setCurrentStep(resultPageStep);
        return (React.createElement(ResultPage, { ...resultPage, layout: layout, onComplete: onComplete, variant: background === 'transparent' ? 'modal' : 'default', resultPageStep: resultPageStep, quizId: quizId, quizName: quizName }));
    }
    if (!hasSteps) {
        return null;
    }
    return (React.createElement(StepperForm, { quizId: quizId, quizName: quizName, onLastStepSubmit: onLastStepSubmit, steps: steps, progressBar: progressBar, background: background, onNextStep: onNextStep, setCurrentStep: setCurrentStep }));
};
function StartPage(props) {
    const { buttonText, quizTimeText, onStart } = props;
    return (React.createElement(InfoStep, { ...props, buttons: [{ text: buttonText, onClick: onStart }], subtitle: quizTimeText ? (React.createElement("div", { className: styles.quizTimeText },
            React.createElement(Icon, { name: 'timelapse', size: 'm' }),
            " ",
            React.createElement("span", { className: styles.text }, quizTimeText))) : undefined }));
}
function ResultPage(props) {
    var _a;
    return (React.createElement(InfoStep, { ...props, buttons: (_a = props.buttons) === null || _a === void 0 ? void 0 : _a.map((button) => {
            return {
                ...button,
                onClick: () => {
                    props.onComplete({
                        quizChoice: button.text,
                        quizStep: props.resultPageStep,
                        quizAction: button.url ? 'continue' : 'close',
                    });
                },
            };
        }), imageSize: "s" }));
}
//# sourceMappingURL=quiz-content.js.map